module.exports = __webpack_public_path__ + "media/icons/biznes-129b5160.svg";